import * as React from 'react';
import {
  ITypeTreeConditionObject,
  UIUrvalConditionObjectType,
} from '../../../../../../Types/UrvalTypes';
import { findCollection } from '../../../../../../Model/avenyModelUtils';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { getTypeLabels } from '../../../Condition/Components/TypeTreePicker/Utils/typeConditionUtils';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { ITypeConditionInfo } from '../../../../Utils/urvalUtils';
import TypeTreePickerDialogButton from '../../../Condition/Components/TypeTreePicker/TypeTreePickerDialogButton';
import { ModelContext } from '../../../../../../Model/ModelContext/ModelContext';

interface IProps {
  typeConditionInfo?: ITypeConditionInfo;
  pageNr: number;
  collectionName: string;
  disabled?: boolean;
  setConditionObject: (
    index: number,
    typeConditionInfo: ITypeConditionInfo | undefined,
    newConditionObject: UIUrvalConditionObjectType
  ) => void;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    color: theme.customProperties.Fade.DarkOnLight.lowEmphasis,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
  },
});

/**
 * En header för ett non-extended urval.
 */

export class UrvalSidaHeader extends React.Component<IProps> {
  static contextType = ModelContext;
  declare context: React.ContextType<typeof ModelContext>;

  setTypeConditionObject = (
    newTypeConditionObject: ITypeTreeConditionObject
  ) => {
    const { typeConditionInfo } = this.props;

    if (typeConditionInfo) {
      this.props.setConditionObject(
        typeConditionInfo.index,
        typeConditionInfo,
        newTypeConditionObject
      );
    }
  };

  renderPageLabel = () => {
    const { typeConditionInfo, pageNr, collectionName, disabled } = this.props;
    const typeConditionObject = typeConditionInfo
      ? typeConditionInfo.object
      : undefined;

    const labelPrefix = pageNr === 1 ? 'Visa' : 'Visa även';
    const labelSufix = 'där:';

    const textColor = disabled ? 'textSecondary' : 'inherit';

    if (typeConditionObject != null) {
      return (
        <EDTypography variant="h6" color={textColor}>
          {labelPrefix}{' '}
          {getTypeLabels(typeConditionObject)
            .map(label => label.toLowerCase())
            .join(', ')}{' '}
          {labelSufix}
        </EDTypography>
      );
    } else {
      const collection = findCollection(
        this.context.avenyCollectionMap,
        collectionName
      );
      return (
        <EDTypography variant="h6" color={textColor}>
          {labelPrefix}{' '}
          {collection && collection.RootType.POLabel.toLowerCase()} {labelSufix}
        </EDTypography>
      );
    }
  };

  render() {
    const { classes, typeConditionInfo, disabled } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.label}>{this.renderPageLabel()}</div>
        {typeConditionInfo && (
          <TypeTreePickerDialogButton
            conditionObject={typeConditionInfo.object}
            setConditionObject={this.setTypeConditionObject}
            disabled={disabled}
          />
        )}
      </div>
    );
  }
}

export default withStyles(UrvalSidaHeader, styles);
